import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { CalendarClock } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function ProximosEventosPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-slate-950 text-slate-50 font-sans selection:bg-emerald-500/30" data-id="element-671">
      <Navbar data-id="element-672" />

      <main className="flex items-center justify-center min-h-[80vh] pt-32 pb-20" data-id="element-673">
        <div className="container mx-auto px-4 md:px-6" data-id="element-674">
          <motion.div className="max-w-2xl mx-auto text-center" initial="hidden" animate="visible" variants={fadeInUp} data-id="element-675">
            <div className="w-20 h-20 rounded-2xl bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center mx-auto mb-8" data-id="element-676">
              <CalendarClock className="w-10 h-10 text-emerald-400" data-id="element-677" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight" data-id="element-678">
              Próximos Eventos
            </h1>
            <p className="text-lg md:text-xl text-slate-400 leading-relaxed" data-id="element-679">
              Prontamente podrás comprar tus entradas a través de nuestro
              portal.
            </p>
            <div className="mt-10 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-900 border border-slate-800 text-slate-400 text-sm" data-id="element-680">
              <span className="relative flex h-2.5 w-2.5" data-id="element-681">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" data-id="element-682"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500" data-id="element-683"></span>
              </span>
              Próximamente disponible
            </div>
          </motion.div>
        </div>
      </main>

      <Footer data-id="element-684" />
    </div>;
}